/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../$$_gendir/node_modules/ng2-completer/components/completer-cmp.ngfactory';
import * as i2 from 'ng2-completer/components/completer-cmp';
import * as i3 from 'ng2-completer/services/completer-service';
import * as i4 from '@angular/forms';
import * as i5 from '@angular/common';
import * as i6 from './timeslots-table.ngfactory';
import * as i7 from '../../../app/components/timeslots-table';
import * as i8 from '@ngrx/store/src/store';
import * as i9 from '../../../app/services/modal';
import * as i10 from '../../../app/components/workshop-bookings';
import * as i11 from '@ngrx/effects/src/actions';
const styles_WorkshopBookingsComponent:any[] = ([] as any[]);
export const RenderType_WorkshopBookingsComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_WorkshopBookingsComponent,data:{}});
function View_WorkshopBookingsComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),9,'div',[['class',
      'input-group campus']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),8,'div',[['class',
      'ig__content-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),5,'ng2-completer',
      [['id','campus'],['name','campus']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
          (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
          [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
              (null as any)]],[[(null as any),'ngModelChange'],[(null as any),'selected']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('ngModelChange' === en)) {
          const pd_0:any = ((<any>(_co.campusSearchStr = $event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('selected' === en)) {
          const pd_1:any = ((<any>_co.selectedCampus($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i1.View_CompleterCmp_0,i1.RenderType_CompleterCmp)),i0.ɵdid(3,12697600,(null as any),
      0,i2.CompleterCmp,[i3.CompleterService,i0.ChangeDetectorRef],{minSearchLength:[0,
          'minSearchLength'],openOnFocus:[1,'openOnFocus'],initialValue:[2,'initialValue'],
          datasource:[3,'datasource']},{selected:'selected'}),i0.ɵprd(1024,(null as any),
      i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.CompleterCmp]),i0.ɵdid(5,671744,(null as any),0,i4.NgModel,[[8,(null as any)],
      [8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{name:[0,'name'],
      model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),i4.NgControl,
      (null as any),[i4.NgModel]),i0.ɵdid(7,16384,(null as any),0,i4.NgControlStatus,
      [i4.NgControl],(null as any),(null as any)),(_l()(),i0.ɵeld(8,0,(null as any),
      (null as any),1,'label',[['for','campus']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['Campus']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_7:any = 0;
        const currVal_8:any = true;
        const currVal_9:any = _co.campuses[0];
        const currVal_10:any = _co.campusCompleter;
        _ck(_v,3,0,currVal_7,currVal_8,currVal_9,currVal_10);
        const currVal_11:any = 'campus';
        const currVal_12:any = _co.campusSearchStr;
        _ck(_v,5,0,currVal_11,currVal_12);
      },(_ck,_v) => {
        const currVal_0:any = i0.ɵnov(_v,7).ngClassUntouched;
        const currVal_1:any = i0.ɵnov(_v,7).ngClassTouched;
        const currVal_2:any = i0.ɵnov(_v,7).ngClassPristine;
        const currVal_3:any = i0.ɵnov(_v,7).ngClassDirty;
        const currVal_4:any = i0.ɵnov(_v,7).ngClassValid;
        const currVal_5:any = i0.ɵnov(_v,7).ngClassInvalid;
        const currVal_6:any = i0.ɵnov(_v,7).ngClassPending;
        _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
      });
}
function View_WorkshopBookingsComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),9,'div',[['class',
      'input-group workshop']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),8,'div',[['class',
      'ig__content-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),5,'ng2-completer',
      [['id','workshop'],['name','workshop']],[[2,'ng-untouched',(null as any)],[2,
          'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
          (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
          'selected']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('ngModelChange' === en)) {
          const pd_0:any = ((<any>(_co.workshopSearchStr = $event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('selected' === en)) {
          const pd_1:any = ((<any>_co.selectedWorkshop($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i1.View_CompleterCmp_0,i1.RenderType_CompleterCmp)),i0.ɵdid(3,12697600,(null as any),
      0,i2.CompleterCmp,[i3.CompleterService,i0.ChangeDetectorRef],{minSearchLength:[0,
          'minSearchLength'],openOnFocus:[1,'openOnFocus'],initialValue:[2,'initialValue'],
          datasource:[3,'datasource']},{selected:'selected'}),i0.ɵprd(1024,(null as any),
      i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.CompleterCmp]),i0.ɵdid(5,671744,(null as any),0,i4.NgModel,[[8,(null as any)],
      [8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{name:[0,'name'],
      model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),i4.NgControl,
      (null as any),[i4.NgModel]),i0.ɵdid(7,16384,(null as any),0,i4.NgControlStatus,
      [i4.NgControl],(null as any),(null as any)),(_l()(),i0.ɵeld(8,0,(null as any),
      (null as any),1,'label',[['for','workshop']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['Workshop']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_7:any = 0;
        const currVal_8:any = true;
        const currVal_9:any = _co.workshops[0];
        const currVal_10:any = _co.workshopCompleter;
        _ck(_v,3,0,currVal_7,currVal_8,currVal_9,currVal_10);
        const currVal_11:any = 'workshop';
        const currVal_12:any = _co.workshopSearchStr;
        _ck(_v,5,0,currVal_11,currVal_12);
      },(_ck,_v) => {
        const currVal_0:any = i0.ɵnov(_v,7).ngClassUntouched;
        const currVal_1:any = i0.ɵnov(_v,7).ngClassTouched;
        const currVal_2:any = i0.ɵnov(_v,7).ngClassPristine;
        const currVal_3:any = i0.ɵnov(_v,7).ngClassDirty;
        const currVal_4:any = i0.ɵnov(_v,7).ngClassValid;
        const currVal_5:any = i0.ɵnov(_v,7).ngClassInvalid;
        const currVal_6:any = i0.ɵnov(_v,7).ngClassPending;
        _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
      });
}
function View_WorkshopBookingsComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),9,'div',[['class',
      'input-group two-week-block']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),8,'div',[['class',
      'ig__content-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),5,'ng2-completer',
      [['id','two-week-block'],['name','twoWeekBlock']],[[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
          'selected']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('ngModelChange' === en)) {
          const pd_0:any = ((<any>(_co.twoWeekBlockSearchStr = $event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('selected' === en)) {
          const pd_1:any = ((<any>_co.selectedTwoWeekBlock($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i1.View_CompleterCmp_0,i1.RenderType_CompleterCmp)),i0.ɵdid(3,12697600,(null as any),
      0,i2.CompleterCmp,[i3.CompleterService,i0.ChangeDetectorRef],{minSearchLength:[0,
          'minSearchLength'],openOnFocus:[1,'openOnFocus'],initialValue:[2,'initialValue'],
          datasource:[3,'datasource']},{selected:'selected'}),i0.ɵprd(1024,(null as any),
      i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.CompleterCmp]),i0.ɵdid(5,671744,(null as any),0,i4.NgModel,[[8,(null as any)],
      [8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{name:[0,'name'],
      model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),i4.NgControl,
      (null as any),[i4.NgModel]),i0.ɵdid(7,16384,(null as any),0,i4.NgControlStatus,
      [i4.NgControl],(null as any),(null as any)),(_l()(),i0.ɵeld(8,0,(null as any),
      (null as any),1,'label',[['for','term']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['2 week block']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_7:any = 0;
        const currVal_8:any = true;
        const currVal_9:any = _co.terms[0].twoWeekBlocks[0];
        const currVal_10:any = _co.twoWeekBlockCompleter;
        _ck(_v,3,0,currVal_7,currVal_8,currVal_9,currVal_10);
        const currVal_11:any = 'twoWeekBlock';
        const currVal_12:any = _co.twoWeekBlockSearchStr;
        _ck(_v,5,0,currVal_11,currVal_12);
      },(_ck,_v) => {
        const currVal_0:any = i0.ɵnov(_v,7).ngClassUntouched;
        const currVal_1:any = i0.ɵnov(_v,7).ngClassTouched;
        const currVal_2:any = i0.ɵnov(_v,7).ngClassPristine;
        const currVal_3:any = i0.ɵnov(_v,7).ngClassDirty;
        const currVal_4:any = i0.ɵnov(_v,7).ngClassValid;
        const currVal_5:any = i0.ɵnov(_v,7).ngClassInvalid;
        const currVal_6:any = i0.ɵnov(_v,7).ngClassPending;
        _ck(_v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
      });
}
function View_WorkshopBookingsComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),30,'div',[['class',
      'input-group day-picker']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),29,'div',[['class',
      'wb__day-picker-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),28,'ul',[['class',
      'wb__day-picker']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(3,0,(null as any),(null as any),3,'li',[['class','wb__day monday']],
          (null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedDay('M')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(4,278528,(null as any),0,i5.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,
              'klass'],ngClass:[1,'ngClass']},(null as any)),i0.ɵpod(5,{'active':0,
          'disabled':1}),(_l()(),i0.ɵted(-1,(null as any),['Mon'])),(_l()(),i0.ɵeld(7,
          0,(null as any),(null as any),3,'li',[['class','wb__day tuesday']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedDay('T')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(8,278528,(null as any),0,i5.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,
              'klass'],ngClass:[1,'ngClass']},(null as any)),i0.ɵpod(9,{'active':0,
          'disabled':1}),(_l()(),i0.ɵted(-1,(null as any),['Tu'])),(_l()(),i0.ɵeld(11,
          0,(null as any),(null as any),3,'li',[['class','wb__day wednesday']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedDay('W')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(12,278528,(null as any),0,i5.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,
              'klass'],ngClass:[1,'ngClass']},(null as any)),i0.ɵpod(13,{'active':0,
          'disabled':1}),(_l()(),i0.ɵted(-1,(null as any),['Wed'])),(_l()(),i0.ɵeld(15,
          0,(null as any),(null as any),3,'li',[['class','wb__day thursday']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedDay('R')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16,278528,(null as any),0,i5.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,
              'klass'],ngClass:[1,'ngClass']},(null as any)),i0.ɵpod(17,{'active':0,
          'disabled':1}),(_l()(),i0.ɵted(-1,(null as any),['Thurs'])),(_l()(),i0.ɵeld(19,
          0,(null as any),(null as any),3,'li',[['class','wb__day friday']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedDay('F')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(20,278528,(null as any),0,i5.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,
              'klass'],ngClass:[1,'ngClass']},(null as any)),i0.ɵpod(21,{'active':0,
          'disabled':1}),(_l()(),i0.ɵted(-1,(null as any),['Fri'])),(_l()(),i0.ɵeld(23,
          0,(null as any),(null as any),3,'li',[['class','wb__day saturday']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedDay('S')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(24,278528,(null as any),0,i5.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,
              'klass'],ngClass:[1,'ngClass']},(null as any)),i0.ɵpod(25,{'active':0,
          'disabled':1}),(_l()(),i0.ɵted(-1,(null as any),['Sat'])),(_l()(),i0.ɵeld(27,
          0,(null as any),(null as any),3,'li',[['class','wb__day sunday']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedDay('U')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(28,278528,(null as any),0,i5.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,
              'klass'],ngClass:[1,'ngClass']},(null as any)),i0.ɵpod(29,{'active':0,
          'disabled':1}),(_l()(),i0.ɵted(-1,(null as any),['Sun']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'wb__day monday';
    const currVal_1:any = _ck(_v,5,0,_co.isDayActive('M'),_co.isDayDisabled('M'));
    _ck(_v,4,0,currVal_0,currVal_1);
    const currVal_2:any = 'wb__day tuesday';
    const currVal_3:any = _ck(_v,9,0,_co.isDayActive('T'),_co.isDayDisabled('T'));
    _ck(_v,8,0,currVal_2,currVal_3);
    const currVal_4:any = 'wb__day wednesday';
    const currVal_5:any = _ck(_v,13,0,_co.isDayActive('W'),_co.isDayDisabled('W'));
    _ck(_v,12,0,currVal_4,currVal_5);
    const currVal_6:any = 'wb__day thursday';
    const currVal_7:any = _ck(_v,17,0,_co.isDayActive('R'),_co.isDayDisabled('R'));
    _ck(_v,16,0,currVal_6,currVal_7);
    const currVal_8:any = 'wb__day friday';
    const currVal_9:any = _ck(_v,21,0,_co.isDayActive('F'),_co.isDayDisabled('F'));
    _ck(_v,20,0,currVal_8,currVal_9);
    const currVal_10:any = 'wb__day saturday';
    const currVal_11:any = _ck(_v,25,0,_co.isDayActive('S'),_co.isDayDisabled('S'));
    _ck(_v,24,0,currVal_10,currVal_11);
    const currVal_12:any = 'wb__day sunday';
    const currVal_13:any = _ck(_v,29,0,_co.isDayActive('U'),_co.isDayDisabled('U'));
    _ck(_v,28,0,currVal_12,currVal_13);
  },(null as any));
}
function View_WorkshopBookingsComponent_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),2,'div',[['class',
      'wb__timeslots-table-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),1,'timeslots-table',
      ([] as any[]),(null as any),(null as any),(null as any),i6.View_TimeslotsTableComponent_0,
      i6.RenderType_TimeslotsTableComponent)),i0.ɵdid(2,114688,(null as any),0,i7.TimeslotsTableComponent,
      [i8.Store,i9.ModalService],{tutorTimeslots:[0,'tutorTimeslots'],twoWeekBlock:[1,
          'twoWeekBlock']},(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.timeslots;
    const currVal_1:any = _co.activeTwoWeekBlock;
    _ck(_v,2,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_WorkshopBookingsComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),23,'div',[['class',
      'workshop-bookings']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),22,'div',[['class',
      'wb__content-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),19,'div',[['class',
      'wb__filters']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(3,0,(null as any),(null as any),18,'div',[['class','input-row']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(4,0,(null as any),(null as any),9,'div',[['class','input-group term']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(5,0,(null as any),(null as any),8,'div',[['class','ig__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(6,0,(null as any),(null as any),5,'ng2-completer',[['id','term'],
          ['name','term']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'selected']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i10.WorkshopBookingsComponent = _v.component;
            if (('ngModelChange' === en)) {
              const pd_0:any = ((<any>(_co.termSearchStr = $event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
              const pd_1:any = ((<any>_co.selectedTerm($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i1.View_CompleterCmp_0,i1.RenderType_CompleterCmp)),i0.ɵdid(7,12697600,
          (null as any),0,i2.CompleterCmp,[i3.CompleterService,i0.ChangeDetectorRef],
          {minSearchLength:[0,'minSearchLength'],openOnFocus:[1,'openOnFocus'],initialValue:[2,
              'initialValue'],datasource:[3,'datasource']},{selected:'selected'}),
      i0.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.CompleterCmp]),i0.ɵdid(9,671744,(null as any),0,i4.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i4.NgControl,(null as any),[i4.NgModel]),i0.ɵdid(11,16384,(null as any),
          0,i4.NgControlStatus,[i4.NgControl],(null as any),(null as any)),(_l()(),
          i0.ɵeld(12,0,(null as any),(null as any),1,'label',[['for','term']],(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(-1,
          (null as any),['Term'])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_WorkshopBookingsComponent_1)),i0.ɵdid(15,16384,(null as any),
          0,i5.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_WorkshopBookingsComponent_2)),
      i0.ɵdid(17,16384,(null as any),0,i5.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_WorkshopBookingsComponent_3)),i0.ɵdid(19,
          16384,(null as any),0,i5.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_WorkshopBookingsComponent_4)),i0.ɵdid(21,16384,(null as any),
          0,i5.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_WorkshopBookingsComponent_5)),
      i0.ɵdid(23,16384,(null as any),0,i5.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i10.WorkshopBookingsComponent = _v.component;
    const currVal_7:any = 0;
    const currVal_8:any = true;
    const currVal_9:any = _co.terms[0];
    const currVal_10:any = _co.termCompleter;
    _ck(_v,7,0,currVal_7,currVal_8,currVal_9,currVal_10);
    const currVal_11:any = 'term';
    const currVal_12:any = _co.termSearchStr;
    _ck(_v,9,0,currVal_11,currVal_12);
    const currVal_13:any = (_co.workshops.length > 0);
    _ck(_v,15,0,currVal_13);
    const currVal_14:any = (_co.workshops.length > 0);
    _ck(_v,17,0,currVal_14);
    const currVal_15:any = (_co.workshops.length > 0);
    _ck(_v,19,0,currVal_15);
    const currVal_16:any = (_co.workshops.length > 0);
    _ck(_v,21,0,currVal_16);
    const currVal_17:any = (_co.workshops.length > 0);
    _ck(_v,23,0,currVal_17);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,11).ngClassUntouched;
    const currVal_1:any = i0.ɵnov(_v,11).ngClassTouched;
    const currVal_2:any = i0.ɵnov(_v,11).ngClassPristine;
    const currVal_3:any = i0.ɵnov(_v,11).ngClassDirty;
    const currVal_4:any = i0.ɵnov(_v,11).ngClassValid;
    const currVal_5:any = i0.ɵnov(_v,11).ngClassInvalid;
    const currVal_6:any = i0.ɵnov(_v,11).ngClassPending;
    _ck(_v,6,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
export function View_WorkshopBookingsComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'workshop-bookings',
      ([] as any[]),(null as any),(null as any),(null as any),View_WorkshopBookingsComponent_0,
      RenderType_WorkshopBookingsComponent)),i0.ɵdid(1,245760,(null as any),0,i10.WorkshopBookingsComponent,
      [i8.Store,i3.CompleterService,i11.Actions],(null as any),(null as any))],(_ck,
      _v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const WorkshopBookingsComponentNgFactory:i0.ComponentFactory<i10.WorkshopBookingsComponent> = i0.ɵccf('workshop-bookings',
    i10.WorkshopBookingsComponent,View_WorkshopBookingsComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/$$_gendir/app/components/workshop-bookings.ngfactory.ts